export default __webpack_public_path__ + "static/vincent-portrait-e7506bdafa1fd38ad7bfa7cf4e1ff2ba.jpg";